import React from 'react';
import PropTypes from 'prop-types';

import FormLabel from 'react-bootstrap/FormLabel';

import './module.css';

const ACTIVATED_STATUS = 'Activated';
const RENEWED_STATUS = 'Renewed';
const EXPIRED_STATUS = 'Expired';

const labelStyles = {
  display: 'inline-block',
  fontSize: '9px',
  width: '80px',
  padding: '5px 2px'
};

const ContractStatusLabel = ({ status }) => {
  let variant = 'default';

  if (status === ACTIVATED_STATUS) {
    variant = 'success';
  }

  if (status === RENEWED_STATUS) {
    variant = 'warning';
  }

  if (status === EXPIRED_STATUS) {
    variant = 'danger';
  }

  return (
    <FormLabel className="label" styleName={`label-${variant}`} variant={variant} style={labelStyles}>
      {status}
    </FormLabel>
  );
};

ContractStatusLabel.propTypes = {
  status: PropTypes.string.isRequired
};

export default ContractStatusLabel;
